import React, { useState, useEffect } from "react";
import axios from "axios";
import misionn from "../../../images/misionn.jpg";
import vision from "../../../images/vision.jpg";
import { FaEdit, FaSave } from "react-icons/fa";
import "./missionvissioncards.css"
// Styles
const containerStyle = {
  marginTop: "10px",
  border: "1px solid #bbb",
  borderRadius: "10px",
};

const cardWrapperStyle = {
  // display: "flex",
  justifyContent: "center",
  gap: "40px",
  overflowX: "auto",
  flexWrap: "nowrap",
  padding: "40px",
  borderRadius: "20px",
  border: "none"
};

const baseCardStyle = {
  backgroundColor: "#fff",
  borderRadius: "16px",
  border: "1px solid #b15cd6",
  padding: "35px 30px",
  // width: "460px",
  boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
  textAlign: "center",
  transition: "all 0.3s ease-in-out",
  cursor: "default",
  position: "relative",
};

const titleBaseStyle = {
  fontSize: "26px",
  fontWeight: "700",
  marginBottom: "14px",
};

const descBaseStyle = {
  fontSize: "16px",
  lineHeight: "1.6",
  color: "#333",
  textAlign: "justify",
};

const sectionTitleStyle = {
  textAlign: "center",
  fontSize: "36px",
  fontWeight: "800",
  color: "rgb(177 93 198)",
  letterSpacing: "0.5px",
  marginBottom: "-20px",
  marginTop: "10px",
};

const textAreaStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "8px",
  resize: "none",
  fontSize: "16px",
};

const imageStyle = {
  width: "80px",
  height: "80px",
  objectFit: "cover",
  borderRadius: "50%",
  marginBottom: "20px",
  border: "2px solid #b15dc6",
};

// ✅ Card Component
const Card = ({ image, title, value, onChange }) => {
  return (
    <div style={baseCardStyle} className="mission-vission-cards">
      <img src={image} alt={title} style={imageStyle} />
      <h3 style={titleBaseStyle}>{title}</h3>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={5}
        style={textAreaStyle}
      />
    </div>
  );
};

// ✅ Main Component
const MissionVisionCards = () => {
  const [mission, setMission] = useState("");
  const [visionDesc, setVisionDesc] = useState("");
  const [userId, setUserId] = useState("");
  const [aboutUsId, setAboutUsId] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [vendorId, setVendorId] = useState(null);

  // ✅ Get userId from localStorage and fetch aboutUs data
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);
  useEffect(() => {
    if (vendorId) {
      fetchAboutUsData(vendorId);
    }
  }, [vendorId]);
  // ✅ Function to fetch existing About Us data
  const fetchAboutUsData = async (vendorId) => {
    const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

    if (!token) {
      console.error("Authorization token is missing. Please log in again.");
      return;
    }

    try {
      const res = await axios.get(
        `https://backend.maamaas.com/food/aboutus/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}` // ✅ Attach token in headers
          }
        }
      );

      const data = res.data;
      setAboutUsId(data?.aboutUsId || "");
      setMission(data?.mission || "");
      setVisionDesc(data?.vision || "");

      // Optional: store in localStorage
      // localStorage.setItem("aboutUsId", data?.aboutUsId || "");

      console.log("Fetched About Us:", data);
    } catch (err) {
      console.error("Fetch About Us Error:", err.response?.data || err.message);
    }
  };


  useEffect(() => {
    if (vendorId) {
      fetchAboutUsData(vendorId);
    }
  }, [vendorId]);

  // ✅ Function to handle Save or Edit button click
  const handleSave = async () => {
    if (!vendorId || !aboutUsId) {
      return alert("User ID or About Us ID not found!");
    }

    if (!mission.trim() || !visionDesc.trim()) {
      return alert("Fields cannot be empty!");
    }

    const payload = {
      mission,
      vision: visionDesc,
    };

    const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage
    if (!token) {
      alert("Authorization token missing. Please log in again.");
      return;
    }

    try {
      const res = await axios.put(
        `https://backend.maamaas.com/food/aboutus/gopi/${aboutUsId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Add token in headers
            "Content-Type": "application/json",
          },
        }
      );

      console.log("PUT Response:", res.data);
      alert("Mission and Vision updated successfully!");
      setIsEditing(false); // Exit edit mode after saving
    } catch (err) {
      console.error("Axios Error:", err.response?.data || err.message);
      alert("Failed to update data: " + (err.response?.data?.message || err.message));
    }
  };

  // ✅ Handle Add Button Click
  const handleSubmit = async () => {
    if (!userId) return alert("User ID not found!");
    if (!mission.trim() || !visionDesc.trim()) return alert("Fields cannot be empty!");

    const token = localStorage.getItem("authToken"); // ✅ Get token

    if (!token) {
      alert("Auth token not found. Please log in again.");
      return;
    }

    const payload = {
      mission,
      vision: visionDesc,
    };

    try {
      const res = await axios.post(
        `https://backend.maamaas.com/food/aboutus/add/${vendorId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Include token in headers
          },
        }
      );
      console.log("POST Response:", res.data);
      alert("Mission and Vision added successfully!");

      // Optional: Refresh the aboutUsId after POST
      fetchAboutUsData(userId);
    } catch (err) {
      console.error("Axios Error:", err.response?.data || err.message);
      alert("Failed to add data: " + (err.response?.data?.message || err.message));
    }
  };


  return (
    <section style={containerStyle}>
      <div style={{ justifyContent: "center", gap: "20px" }} className="card-data-contnetcode">
        <h1 style={sectionTitleStyle}>OUR COMMITMENTS</h1>
        <div style={{ textAlign: "center", marginTop: "20px" }} className="card-data-contnetcode">
          <button
            onClick={handleSubmit}
            style={{
              backgroundColor: "#b15dc6",
              color: "#fff",
              fontSize: "14px",
              padding: "10px 20px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              marginTop: "-20px",
            }}
          >
            Add +
          </button>
          <button
            onClick={() => {
              if (isEditing) {
                handleSave(); // Call save function
              } else {
                setIsEditing(true); // Toggle edit mode
              }
            }}
            style={{
              backgroundColor: "#b15dc6",
              color: "#fff",
              fontSize: "14px",
              padding: "10px 15px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              marginTop: "-20px",
              marginLeft: "10px"
            }}
          >
            {isEditing ? <FaSave /> : <FaEdit />}
          </button>
        </div>
      </div>

      <div style={cardWrapperStyle} className="mission-vission-card-wrapper">
        <Card
          image={misionn}
          title="Our Mission"
          value={mission}
          onChange={setMission}
        />
        <Card
          image={vision}
          title="Our Vision"
          value={visionDesc}
          onChange={setVisionDesc}
        />
      </div>
    </section>
  );
};

export default MissionVisionCards;
